import { render, staticRenderFns } from "./edition2.vue?vue&type=template&id=11871d6c&scoped=true"
import script from "./edition2.vue?vue&type=script&lang=js"
export * from "./edition2.vue?vue&type=script&lang=js"
import style0 from "./edition2.vue?vue&type=style&index=0&id=11871d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11871d6c",
  null
  
)

export default component.exports